import Excel, {Workbook} from 'exceljs'
import {ILocale} from "../../../services/localize.service";
import {saveAs} from 'file-saver';

export const getFileFromUrl = async (url: string, outFileName: string): Promise<File> => {
    let response = await fetch(url);
    let data = await response.blob();
    let metadata = {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'};
    return new File([data], outFileName, metadata);
};

const getBufferFromFile = async (file: File): Promise<Buffer> => {
    return new Promise(resolve => {
        const reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = () => {
            const buffer = reader.result;
            resolve(buffer as Buffer);
        };
    });
};

const getWorkbookFromBuffer = async (buffer: Buffer): Promise<Workbook> => {
    return new Promise(resolve => {
        const wb = new Excel.Workbook();
        wb.xlsx.load(buffer).then(workbook => {
            resolve(workbook);
        });
    })
};

/**
 * Получаем Workbook
 */
export const getWorkBook = async (): Promise<Workbook> => {
    /**
     * Получаем файл из урл линка
     */
    const file = await getFileFromUrl("./billing/bill.xlsx", "bill.xlsx");
    /**
     * Получаем буффер из файла
     */
    const buffer = await getBufferFromFile(file);
    /**
     * Конвертируем буффер в workbook Excel
     */
    return await getWorkbookFromBuffer(buffer);

};

export const saveXLSFile = async (wb: Workbook, name: string) => {
    await wb.xlsx.writeBuffer().then((data: any) => {
        saveAs(new Blob([data]), `${name}.xlsx`);
    }).catch((err: any) => console.log('err', err))
};

export const savePDFFile = async (pdfBuffer: Buffer, name: string) => {
    saveAs(new Blob([pdfBuffer]), `${name}.pdf`);
};


interface IPDV {
    pdv: number;
    bezPdv: number;
}

export const getPDV = (sum: number, percent: number): IPDV => {
    const bezPdv = parseFloat((sum/(percent / 100 + 1)).toFixed(2));
    const pdv =  parseFloat((sum - bezPdv).toFixed(2));

    return {pdv, bezPdv};
};


